export default __webpack_public_path__ + "static/media/apocittiinterview.9a3557cf.png";